export default __webpack_public_path__ + "static/media/apple-cut@2x.31fdcb54.png";